import { __read, __spreadArray } from "tslib";
import { useResponsiveValue } from '@theme-ui/match-media';
import { range, remove } from 'lodash-es';
import React from 'react';
import { Avatar, Box, ContentLoader, Flex, Tooltip } from '@marvelapp/ui';
import ModalLink from '../Modal/ModalLink';
import MoreCollaborators from './MoreCollaborators';
/** @param {any} */
export default function CollaboratorList(_a) {
    var collaborators = _a.collaborators, collaboratorsAggregate = _a.collaboratorsAggregate, disableTooltip = _a.disableTooltip, isLoading = _a.isLoading, ownerPk = _a.ownerPk, shareUrl = _a.shareUrl, testId = _a.testId, _b = _a.tooltipPosition, tooltipPosition = _b === void 0 ? 'bottom' : _b, _c = _a.size, size = _c === void 0 ? 34 : _c;
    var MAX_LENGTH = useResponsiveValue([5, 5, 5, 5, 3, 3, 5]);
    if (isLoading) {
        return (React.createElement(Flex, { "data-testid": "".concat(testId, "-loading"), marginRight: "10px" }, range(4).map(function (loader, index) { return (React.createElement(Box, { key: loader, mr: "-6px", position: "relative", zIndex: range(4).length - index },
            React.createElement(ContentLoader, { border: "3px solid", borderColor: "white", borderRadius: 18, height: size + 2, key: loader, kind: "medium", width: size + 2 }))); })));
    }
    if (!collaborators)
        return null;
    var sortedCollaborators = getSortedCollaborators(ownerPk, collaborators);
    var moreThanMax = sortedCollaborators.length > MAX_LENGTH;
    var remainingCollaborators = collaboratorsAggregate
        ? collaboratorsAggregate - MAX_LENGTH
        : sortedCollaborators.length - MAX_LENGTH;
    return (React.createElement(ModalLink, { display: ['none', 'block'], mr: 2, to: shareUrl, "data-testid": "open-share-modal" },
        React.createElement(Flex, { alignItems: "center", mr: 1 },
            sortedCollaborators.slice(0, MAX_LENGTH).map(function (collaborator, index) {
                return (React.createElement(Box, { key: collaborator.pk, mr: "-6px", position: "relative", zIndex: sortedCollaborators.length - index },
                    React.createElement(Tooltip, { content: disableTooltip ? undefined : collaborator.username, cursor: shareUrl ? 'pointer' : 'initial', display: "block", position: tooltipPosition },
                        React.createElement(Avatar, { borderWidth: 3, email: collaborator.email, pk: collaborator.pk, size: size, src: collaborator.avatarUrl }))));
            }),
            moreThanMax && (React.createElement(Box, { mr: "-6px", position: "relative", zIndex: 1 },
                React.createElement(Tooltip, { content: disableTooltip
                        ? undefined
                        : "And ".concat(remainingCollaborators, " more"), cursor: shareUrl ? 'pointer' : 'initial', position: tooltipPosition },
                    React.createElement(MoreCollaborators, { num: remainingCollaborators, size: size })))))));
}
function getSortedCollaborators(ownerPk, collaborators) {
    var collaboratorNodes = collaborators.edges.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var owner = remove(collaboratorNodes, function (_a) {
        var pk = _a.pk;
        return pk === ownerPk;
    });
    return __spreadArray(__spreadArray([], __read(owner), false), __read(collaboratorNodes), false);
}
